import React from 'react';
import styles from '../VideoAnalyzer.module.css';
import { SmileIcon, Hand, PersonStandingIcon } from 'lucide-react';
import MetricCard from './MetricCard';
import LoadingCard from './LoadingCard';

const MetricsOverlay = ({
    modelsLoading,
    loadingProgress,
    facialEngagement,
    handsVisible,
    goodPosture,
    facialEngagementProgress,
    handsProgress,
    postureProgress
}) => {
    const normalizePercentage = (value) => {
        return Math.min(Math.max(Math.round(value * 100) / 100, 0), 100);
    };

    const getFeedbackMessage = (type) => {
        switch (type) {
            case 'facial':
                return facialEngagement > 30 ? "Great facial engagement!" : "Try to be more expressive";
            case 'hands':
                return handsVisible ? "Effective hand gestures" : "Keep hands above and visible";
            case 'posture':
                return goodPosture ? "Professional posture maintained" : "Consider adjusting posture";
            default:
                return "";
        }
    };

    return (
        <div className={styles.metricsOverlay}>
            <div className={styles.metricsGrid}>
                {modelsLoading ? (
                    <>
                        <LoadingCard
                            title="Face Analysis"
                            description="Loading facial recognition model..."
                            isLoaded={loadingProgress.face}
                        />
                        <LoadingCard
                            title="Pose Detection"
                            description="Loading pose estimation model..."
                            isLoaded={loadingProgress.pose}
                        />
                        <LoadingCard
                            title="Hand Tracking"
                            description="Loading hand detection model..."
                            isLoaded={loadingProgress.hand}
                        />
                    </>
                ) : (
                    <>
                        <MetricCard
                            icon={<SmileIcon size={20} />}
                            title="Facial Engagement"
                            value={normalizePercentage(facialEngagement)}
                            message={getFeedbackMessage('facial')}
                            progress={facialEngagementProgress}
                        />
                        <MetricCard
                            icon={<Hand size={20} />}
                            title="Gesture Activity"
                            value={normalizePercentage(handsVisible ? 100 : 0)}
                            message={getFeedbackMessage('hands')}
                            progress={handsProgress}
                        />
                        <MetricCard
                            icon={<PersonStandingIcon size={20} />}
                            title="Posture Analysis"
                            value={normalizePercentage(goodPosture ? 100 : 0)}
                            message={getFeedbackMessage('posture')}
                            progress={postureProgress}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

export default MetricsOverlay;